<template>
  <div class="card">
    <!--begin::Card body-->
    <div class="card-body">
      <!--begin::Heading-->
      <div class="text-left py-0 my-5">
        <div class="alinear row">
          <div class="col-md-6">
            <h2 class="fs-1x fw-bolder mb-5">
              Ordenes Judiciales registradas en el <br />
              Sistema Estado Digital - Régimen Penitenciario
            </h2>
          </div>
          <div class="image col-md-4">
            <p>
              <span v-if="tipo === 'agregar'"
                ><strong>NOMBRE PPL :</strong> {{ data_order.nombres }}
                {{ data_order.primer_apellido }}
                {{ data_order.segundo_apellido }}</span
              >
              <span v-else-if="tipo === 'verificar'"
                ><strong>NOMBRE PPL :</strong>
                {{ data_order.persona_ppl }}</span
              >
              <br />
              <strong>NÚMERO DE DOCUMENTO :</strong>
              {{ data_order.nro_documento }}<br />
              <strong>CÓDIGO FILE :</strong> {{ data_order.codigo_file_ppl
              }}<br />
              <strong> SITUACIÓN JURÍDICA ACTUAL :</strong>
              {{ data_order.tipo_mandamiento }}
              <br />
            </p>
          </div>
          <div class="image col-md-2">
            <img
              src="../../../public/media/blank.png"
              class="img-fluid img-thumbnail"
              width="200"
              height="200"
              alt="without_image"
              v-if="data_order.imagen_segip === 'null'"
            />
            <img
              v-else
              :src="data_order.imagen_segip"
              class="img-fluid img-thumbnail"
              width="200"
              height="200"
              alt="SegipImage"
            />
          </div>
        </div>
      </div>
      <button
        v-if="tipo === 'agregar'"
        class="alinear card-btn three"
        @click="
          register_or_add_new_order({
            id_persona: data_order.id_persona,
            id_orden: 0,
            add: 'register',
          })
        "
      >
        Nueva Orden Judicial
      </button>
      <div
        v-if="data_read.length > 1 && tipo !== 'agregar'"
        class="alert alert-warning d-flex align-items-center mx-5 my-2"
        role="alert"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="100"
          fill="currentColor"
          class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
          viewBox="0 0 20 20"
          role="img"
          aria-label="Warning:"
        >
          <path
            d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
          />
        </svg>
        <div style="text-align: justify">
          <strong>
            No es posible aprobar la libertad definitiva por que se tiene más de
            un proceso judicial registrado en el sistema Estado Digital -
            Régimen Penitenciario</strong
          >
        </div>
      </div>
      <div class="row col-12 p-5">
        <div
          v-for="data of data_read"
          :key="data.id_ordenes_judiciales_ppl"
          :class="data_read.length === 1 ? 'col-md-12 my-4' : 'col-md-6 my-4'"
        >
          <div class="card-wrap h-100 my-4">
            <div
              class="alinear row card-header"
              :style="[
                data_read.length === 1
                  ? 'background: linear-gradient(93deg, rgba(94,114,235,1) 0%, rgba(255,145,144,1) 100%)'
                  : data.color,
              ]"
            >
              <div class="col-sm-9 mt-5 ml-10 mb-2">
                <div
                  class="alinear"
                  v-for="(item, index) in delitos_read"
                  :key="index"
                >
                  <h1
                    style="color: white; font-size: 2em"
                    v-if="
                      item.id_ordenes_judiciales_ppl ===
                      data.id_ordenes_judiciales_ppl
                    "
                  >
                    <span
                      style="font-size: 0.5em"
                      class="badge badge-pill badge-light bdg_name"
                    >
                      {{ item.descripcion_delito }}</span
                    >
                  </h1>
                </div>
              </div>
              <div v-if="data.estado_ordenes" class="col-sm-3">
                <i style="color: yellow" class="fas fa-star"></i>
                <p style="color: yellow" class="pt-2">PRINCIPAL</p>
              </div>
            </div>
            <div class="card-content">
              <h1 class="card-title">
                {{ data.descripcion_tipo_mandamiento }}
              </h1>
              <div class="card-text">
                <p>
                  <strong>FECHA ORDEN JUDICIAL : </strong
                  >{{ fecha_literal(data.fecha_orden_judicial) }}
                </p>
                <p>
                  <strong>FECHA DE INGRESO AL RECINTO PENITENCIARIO : </strong
                  >{{ fecha_literal(data.fecha_ingreso_recinto) }}
                </p>
                <p>
                  <strong>NOMBRE JUEZ : </strong>{{ data.nombre_completo_juez }}
                </p>
                <p>
                  <strong>NOMBRE JUZGADO : </strong>{{ data.nombre_juzgado }}
                </p>
                <p>
                  <strong>TIPO JUZGADO : </strong
                  >{{ data.descripcion_tipo_juzgado }}
                </p>
                <p>
                  <strong> CÓDIGO ÚNICO DE PROCESO: </strong
                  >{{ data.nombre_codigo }} - {{ data.codigo_unico }}
                </p>
                <p>
                  <strong>RECINTO PENITENCIARIO : </strong
                  >{{ data.nombre_recinto_penitenciario }} -
                  {{ data.departamento }}
                </p>
                <p v-if="data.anios_sentencia">
                  <strong>TIEMPO DE SENTENCIA : </strong
                  >{{ data.anios_sentencia }} AÑOS
                  {{ data.meses_sentencia }} MESES
                </p>
                <p v-if="data.fecha_salida_sentencia">
                  <strong>FECHA DE SALIDA SEGÚN SENTENCIA : </strong
                  >{{ fecha_literal(data.fecha_salida_sentencia) }}
                </p>
                <p v-if="data.fecha_ingreso_recinto">
                  <strong>TIEMPO TRANSCURRIDO : </strong
                  >{{ calcularTiempoTranscurrido(data.fecha_ingreso_recinto) }}
                </p>
                <p v-if="data.fecha_salida_sentencia">
                  <strong>TIEMPO RESTANTE : </strong
                  >{{ calcularTiempoRestante(data.fecha_salida_sentencia) }}
                </p>
                <p v-if="data.obs_ordenes">
                  <strong>OBSERVACIONES : </strong>{{ data.obs_ordenes }}
                </p>
                <p>
                  <strong>PDF DOCUMENTO ORDEN JUDICIAL : </strong
                  ><span
                    title="Ver orden judicial"
                    v-if="data.documento_respaldo"
                    class="badge bg-primary"
                    @click="ver_archivo(data.id_ordenes_judiciales_ppl_encriptado)"
                    >{{ data.documento_respaldo ? "VER" : "NO" }}</span
                  >
                  <button
                    v-if="rol === 'admin' && data.documento_respaldo"
                    type="button"
                    class="btn px-3"
                    @click="deleteResolution(data.id_ordenes_judiciales_ppl_encriptado)"
                  >
                    <i
                      title="Eliminar orden judicial"
                      style="font-size: 1.5em; color: indianred"
                      class="fas fa-file-circle-xmark"
                    ></i>
                  </button>
                  <button
                    v-if="!data.documento_respaldo"
                    type="button"
                    class="btn btn-success btn-sm"
                    @click="uploadResolution(data.id_ordenes_judiciales_ppl_encriptado)"
                  >
                    Subir archivo
                  </button>
                  <input
                    :id="data.id_ordenes_judiciales_ppl_encriptado"
                    type="file"
                    ref="file"
                    @change="
                      handleFileUpload($event, data.id_ordenes_judiciales_ppl_encriptado)
                    "
                    accept="application/pdf"
                    hidden
                  />
                </p>
                <p v-if="data.seguido_por">
                  <strong>SEGUIDO POR : </strong>{{ data.seguido_por }}
                </p>
              </div>
              <button
                v-if="
                  data_read.length > 1 &&
                  tipo !== 'agregar' &&
                  data.id_orden_padre &&
                  data.id_ordenes_judiciales_ppl ===
                    data_order.cod_ordenes_judiciales_ppl
                "
                style="min-width: 41%"
                class="card-btn three"
                @click="aprobar_salida(data_order.id_traslado_salida)"
              >
                Aprobar Salida
              </button>
              <button
                v-else-if="
                  data_read.length === 1 &&
                  tipo !== 'agregar' &&
                  data.id_ordenes_judiciales_ppl ===
                    data_order.cod_ordenes_judiciales_ppl
                "
                style="min-width: 41%"
                class="card-btn three"
                @click="aprobar_salida(data_order.id_traslado_salida)"
              >
                Aprobar Salida
              </button>
              <button
                v-if="
                  tipo !== 'agregar' &&
                  data_read.length == 1 &&
                  data.id_ordenes_judiciales_ppl ===
                    data_order.cod_ordenes_judiciales_ppl
                "
                style="min-width: 41%"
                class="card-btn four"
                @click="rechazar_salida(data_order.id_traslado_salida)"
              >
                Rechazar Salida
              </button>
              <button
                v-if="tipo !== 'agregar' && data_read.length > 1"
                style="min-width: 41%"
                class="card-btn five"
                @click="registrar_orden_salida(data_order, data)"
              >
                Registrar orden de salida
              </button>
              <button
                v-if="tipo === 'agregar' && !data.id_orden_padre"
                class="card-btn five"
                style="min-width: 41%"
                @click="
                  register_or_add_new_order({
                    id_persona: data_order.id_persona,
                    id_orden: data.id_ordenes_judiciales_ppl_encriptado,
                    add: 'add',
                  })
                "
              >
                Agregar Orden Judicial
              </button>
              <!-- <button
                style="min-width: 41%"
                v-if="tipo === 'agregar' && !data.estado_ordenes"
                class="card-btn seven"
                @click="printKardex(data.id_ordenes_judiciales_ppl, 'nuevo')"
              >
                Imprimir Kardex
              </button> -->
              <button
                v-if="
                  rol === 'admin' &&
                  (tipo === 'agregar' || tipo === 'verificar') &&
                  !data.estado_ordenes
                "
                style="min-width: 41%"
                class="card-btn six"
                @click="
                  turn_principal({
                    id_orden_judicial: data.id_ordenes_judiciales_ppl,
                    id_persona: data_order.id_persona,
                  })
                "
              >
                Convertir Principal
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, ref, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import addTransfersDepartures from "@/addTransfersDepartures/composables/useAddTransferDeparture";
import filiation from "@/filiation/composables/useFiliation";
import formatDate from "@/helpers/formatDate";
import { formatDistance } from "date-fns";
import { es } from "date-fns/esm/locale";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import useAuth from "@/auth/composables/useAuth";
export default defineComponent({
  name: "resumeOrders",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const data_read = ref([]);
    const delitos_read = ref([]);
    const file = ref(null);
    const isAdmin = ref("");
    const isEditor = ref("");
    const { rol } = useAuth();
    const {
      get_dataOrders_ppl,
      approve_liberty_ppl,
      deny_liberty_ppl,
      turn_principal_order,
      printAddTransferDeparture,
      register_order_departure,
    } = addTransfersDepartures();
    const { resolution, passData, uploadFile, deleteFile } = filiation();
    const data_order = JSON.parse(localStorage.getItem("paraAprobar"));
    const tipo = computed(() => route.params.tipo);
    const fecha_literal = (date) => {
      const formattedDate = formatDate(date);
      return formattedDate;
    };
    const printKardex = async (id, tipo) => {
      await printAddTransferDeparture({ id: id, tipo: tipo });
    };
    const uploadResolution = (e) => {
      document.getElementById(e).click();
    };
    const handleFileUpload = async (event, id) => {
      file.value = event.target.files[0];
      const { data } = await uploadFile([file.value, id]);
      if (data.ok == true) {
        Swal.fire({
          title: "Archivo cargado correctamente",
          text: "El archivo pdf de la resolución fue registrado exitosamente.",
          icon: "success",
          buttonsStyling: false,
          confirmButtonText: "Continuar",
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        });
        location.reload();
      } else {
        Swal.fire({
          title: "Error",
          text: "El archivo no pudo ser cargado.",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Continuar",
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        });
      }
    };
    const ver_archivo = async (id) => {
      await resolution(id);
    };
    const swalWithBootstrapButtons = Swal.mixin({
      confirmButtonText: "Continuar",
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });
    const deleteResolution = async (dato) => {
      Swal.fire({
        title: `¿Está seguro de eliminar el archivo PDF del mandamiento?`,
        text: "No podrá revertir esta acción.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, eliminar",
        cancelButtonText: `Cancelar`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { data } = await deleteFile(dato);
          if (data.ok === true) {
            swalWithBootstrapButtons.fire(
              "¡Eliminado!",
              "El archivo fue eliminado satisfactoriamente.",
              "success"
            );
            location.reload();
          } else {
            Swal.fire({
              title: "Error",
              text: "El archivo no pudo ser eliminado.",
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Continuar",
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            });
          }
        }
      });
    };
    const calcularTiempoTranscurrido = (fecha_ingreso) => {
      const fecha_actual = new Date();
      return `Recluido ${formatDistance(new Date(fecha_ingreso), fecha_actual, {
        addSuffix: true,
        locale: es,
      })}`;
    };
    const calcularTiempoRestante = (fecha_salida) => {
      const fecha_actual = new Date();
      if (fecha_salida == null) {
        return;
      } else if (new Date(fecha_salida) >= fecha_actual) {
        return `Cumple ${formatDistance(new Date(fecha_salida), fecha_actual, {
          addSuffix: true,
          locale: es,
        })}`;
      } else if (new Date(fecha_salida) < fecha_actual) {
        return `Cumplió ${formatDistance(new Date(fecha_salida), fecha_actual, {
          addSuffix: true,
          locale: es,
        })}`;
      }
    };
    const aprobar_salida = async (id_salida) => {
      Swal.fire({
        title: "¿Aprobar Salida? \n\n Esta acción no podrá ser revertida.",
        html: `<table style="width: 100%;">
                <tr>
                <th>TIPO SALIDA</th>
                <td>${data_order.descripcion_tipo_mandamiento}</td>
                </tr>
                <tr>
                <th>PRIVADO DE LIBERTAD</th>
                <td>${data_order.persona_ppl}</td>
                </tr>
                <tr>
                <th>RECINTO PENITENCIARIO</th>
                <td>${data_order.anterior}</td>
                </tr>
                <tr>
                <th>JUEZ Y JUZGADO</th>
                <td>${data_order.nombre_completo_autoridad} - ${
          data_order.nombre_juzgado
        }</td>
                </tr>
                
                <tr>
                <th>TIPO CÓDIGO</th>
                <td>${data_order.nombre_codigo} - ${
          data_order.codigo_unico
        }</td>
                </tr>
                 <tr>
                <th>FECHA ORDEN</th>
                <td>${fecha_literal(data_order.fecha_orden)}</td>
                </tr>
                </table>`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, aprobar",
        cancelButtonText: "No, volver",
        customClass: "swal-wide",
        reverseButtons: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { data } = await approve_liberty_ppl(id_salida);
          if (data.ok) {
            Swal.fire(
              `¡Salida por ${data_order.descripcion_tipo_mandamiento} aprobada con éxito!`,
              `La orden de ${data_order.descripcion_tipo_mandamiento} de ${data.message} fue registrada con éxito`,
              "success"
            );
            router.push({
              name: "transfersDeparturesOrderList",
              params: {
                type_order: "salidas",
              },
            });
            await printAddTransferDeparture({ id: data.id, tipo: "salidas" });
          } else {
            Swal.fire(
              `¡Salida por ${data_order.descripcion_tipo_mandamiento} no pudo ser registrada!`,
              `La orden de ${data_order.descripcion_tipo_mandamiento} de ${data_order.nombres} ${data_order.primer_apellido} ${data_order.segundo_apellido} no pudo registrada. <br> Por favor contactese con el administrador.`,
              "error"
            );
          }
        }
      });
    };
    const rechazar_salida = async (id_salida) => {
      Swal.fire({
        title: "¿Rechazar Salida? \n\n Esta acción no podrá ser revertida.",
        html: `<table style="width: 100%; hight">
                <tr>
                <th>TIPO SALIDA</th>
                <td>${data_order.descripcion_tipo_mandamiento}</td>
                </tr>
                <tr>
                <th>PRIVADO DE LIBERTAD</th>
                <td>${data_order.persona_ppl}</td>
                </tr>
                <tr>
                <th>RECINTO PENITENCIARIO</th>
                <td>${data_order.anterior}</td>
                </tr>
                <tr>
                <th>JUEZ Y JUZGADO</th>
                <td>${data_order.nombre_completo_autoridad} - ${
          data_order.nombre_juzgado
        }</td>
                </tr>                
                <tr>
                <th>TIPO CÓDIGO</th>
                <td>${data_order.nombre_codigo} - ${
          data_order.codigo_unico
        }</td>
                </tr>
                 <tr>
                <th>FECHA ORDEN</th>
                <td>${fecha_literal(data_order.fecha_orden)}</td>
                </tr>
                </table>`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, rechazar",
        cancelButtonText: "No, volver",
        customClass: "swal-wide",
        reverseButtons: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { value: text } = await Swal.fire({
            title:
              "Por favor registre el motivo por el cual se rechazó la salida de la persona privada de libertad",
            input: "textarea",
            inputPlaceholder: `Describa los motivos por los cuales se rechazó el mandamiento de ${data_order.descripcion_tipo_mandamiento} de la persona privada de libertad...`,
            confirmButtonText: "Enviar",
            cancelButtonText: "Cancelar",
            customClass: "swal-wide",
            reverseButtons: true,
            inputAttributes: {
              "aria-label": "Registre la información aquí",
            },
            showCancelButton: true,
          });
          if (text) {
            const { data } = await deny_liberty_ppl({
              id_traslado_salida: id_salida,
              detalle: text,
            });
            if (data.ok) {
              Swal.fire(
                `Salida por ${data_order.descripcion_tipo_mandamiento} fue registrada como rechazada`,
                `La orden de ${data_order.descripcion_tipo_mandamiento} de ${data_order.nombres} ${data_order.primer_apellido} ${data_order.segundo_apellido} fue rechazada y registrada.`,
                "success"
              );
              router.push({
                name: "transfersDeparturesOrderList",
                params: {
                  type_order: "salidas",
                },
              });
              await printAddTransferDeparture({ id: data.id, tipo: "salidas" });
            } else {
              Swal.fire(
                `Ocurrió un error al registrar la información`,
                `Por favor contactese con el administrador del sistema`,
                "error"
              );
            }
          }
        }
      });
    };
    const registrar_orden_salida = async (data_order, data_individual) => {
      // enviar data_order.cod_persona y data_order.cod_ordenes_judiciales_ppl
      Swal.fire({
        title:
          "¿Está seguro de registrar la orden de salida definitiva y activar el proceso pendiente?",
        text: "El proceso actual quedará finalizado y se activará el proceso pendiente",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Si, registrar",
        cancelButtonText: "No, cancelar",
        reverseButtons: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { data } = await register_order_departure({
            id_traslado_salida: data_order.id_traslado_salida,
            id_persona: data_order.cod_persona,
            id_orden: data_individual.id_ordenes_judiciales_ppl,
          });
          if (data.ok) {
            Swal.fire({
              title: "Correcto",
              text: `${data.message}`,
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Continuar",
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            }).then(async () => {
              router.push({
                name: "transfersDeparturesOrderList",
                params: {
                  type_order: "salidas",
                },
              });
              await printAddTransferDeparture({ id: data.id, tipo: "salidas" });
            });
          } else {
            Swal.fire({
              title: "Atención",
              text: `Ocurrió un error, por favor contáctese con el administrador.`,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Continuar",
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            });
          }
        }
      });
    };
    const get_data = async () => {
      let color = [
        "background: linear-gradient(93deg, rgba(94,114,235,1) 0%, rgba(255,145,144,1) 100%);",
        "background: linear-gradient(185deg, rgba(43,89,227,1) 0%, rgba(0,185,203,0.8914916308320203) 100%);",
        "background: linear-gradient(185deg, rgba(43,214,227,1) 31%, rgba(76,203,0,0.8914916308320203) 90%);",
        "background: linear-gradient(93deg, rgba(232,164,156,1) 0%, rgba(233,98,156,1) 100%);",
        "background: linear-gradient(93deg, rgba(255,123,137,1) 0%, rgba(121,60,113,1) 100%);",
        "background: linear-gradient(93deg, rgba(28,167,236,1) 0%, rgba(19,28,87,1) 100%)",
        "background: linear-gradient(93deg, rgba(53,187,202,1) 0%, rgba(248,217,15,1) 100%);",
        "background: linear-gradient(93deg, rgba(106,171,156,1) 0%, rgba(88,116,220,1) 100%);",
        "background: linear-gradient(93deg, rgba(250,137,123,1) 0%, rgba(255,221,148,1) 100%);",
        "background: linear-gradient(185deg, rgba(131,161,250,1) 0%, rgba(110,13,221,1) 100%);",
        "background: linear-gradient(93deg, rgba(94,114,235,1) 0%, rgba(255,145,144,1) 100%);",
        "background: linear-gradient(93deg, rgba(233,118,91,1) 0%, rgba(78,148,172,1) 100%);",
        "background: #cc7571;",
        "background: #eeb461;",
        "background: #c73966;",
        "background: #757273;",
        "background: #ab569c;",
        "background: #512056;",
        "background: #3b5385;",
        "background: #5ba8a1;",
      ];
      const { data } = await get_dataOrders_ppl({
        cod_persona: data_order.cod_persona,
        tipo: tipo.value,
      });
      const padres = data.data.filter((el) => el.id_orden_padre === null);
      const hijos = data.data.filter((el) => el.id_orden_padre !== null);
      for (let i = 0; i < padres.length; i++) {
        padres[i].color = color[i];
        for (let j = 0; j < hijos.length; j++) {
          if (hijos[j].id_orden_padre == padres[i].id_ordenes_judiciales_ppl) {
            hijos[j].color = color[i];
          }
        }
      }
      data_read.value = data.data;
      delitos_read.value = data.delitos;
    };
    const register_or_add_new_order = async (data) => {
      const { id_persona, id_orden, add } = data;
      await passData({
        id_persona,
        id_orden_judicial: id_orden,
        tipo: "nuevo",
      });
      router.push({
        name: "addOrTransferOrDeparture",
        params: {
          id_persona,
          id_orden_judicial: id_orden,
          tipo: "nuevo",
          add,
        },
      });
    };
    const turn_principal = async (ids) => {
      Swal.fire({
        title: "¿Está seguro con convertir esta orden judicial como principal?",
        text: "Esta orden judicial se convertirá en la PRINCIPAL del privado de Libertad",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Si, convertir",
        cancelButtonText: "No, cancelar",
        reverseButtons: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { data } = await turn_principal_order(ids);
          if (data.ok) {
            Swal.fire({
              title: "Correcto",
              text: `La orden judicial se actualizó como la principal `,
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Continuar",
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            }).then(async () => {
              router.push({
                name: "listDeprivedLibertybyPrisons",
              });

              //await printKardex(data.id_persona);
            });
          } else {
            Swal.fire({
              title: "Atención",
              text: `Ocurrió un error, por favor contáctese con el administrador.`,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Continuar",
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            });
          }
        }
      });
    };
    get_data();
    onMounted(() => {
      setCurrentPageBreadcrumbs(
        "Ordenes Judiciales registradas",
        // eslint-disable-next-line prettier/prettier
        ["Información"]
      );
      const userLogged = localStorage.getItem("roles").split(",");
      for (let rol of userLogged) {
        if (rol.toUpperCase() === "ADMIN") {
          isAdmin.value = true;
        } else if (rol.toUpperCase() === "EDITOR") {
          isEditor.value = true;
        }
      }
    });

    return {
      isAdmin,
      data_order,
      data_read,
      delitos_read,
      tipo,
      rol,
      fecha_literal,
      uploadResolution,
      handleFileUpload,
      ver_archivo,
      deleteResolution,
      calcularTiempoTranscurrido,
      calcularTiempoRestante,
      aprobar_salida,
      rechazar_salida,
      registrar_orden_salida,
      register_or_add_new_order,
      turn_principal,
      printKardex,
    };
  },
});
</script>
<style>
.image {
  text-align: right;
}
.alinear {
  text-align: left;
}
@media screen and (max-width: 767px) {
  .image {
    text-align: center !important;
  }
  .alinear {
    text-align: center !important;
  }
  .bdg_name {
    font-size: 10px !important;
  }
}
@media screen and (min-width: 767px) {
  .card-wrap:hover {
    transform: scale(1.1);
  }
  .bdg_name {
    font-size: 15px !important;
  }
}
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
}
th,
td {
  padding: 5px;
  text-align: left;
}
* {
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
}
:root {
  --color-text: #616161;
  --color-text-btn: #ffffff;
  --card1-gradient-color1: #f12711;
  --card1-gradient-color2: #f5af19;
  --card2-gradient-color1: #7f00ff;
  --card2-gradient-color2: #e100ff;
  --card3-gradient-color1: #3f2b96;
  --card3-gradient-color2: #a8c0ff;
  --card4-gradient-color1: #11998e;
  --card4-gradient-color2: #38ef7d;
}
/* body{
  font-family: 'Roboto', sans-serif;
  background: linear-gradient(to right, #8e9eab, #eef2f3); 
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 30px;
} */

.card-wrap {
  background: #fff;
  border-radius: 20px;
  border: 5px solid #fff;
  overflow: hidden;
  color: var(--color-text);
  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
/* .card-wrap:hover {
  transform: scale(1.1);
} */
.card-header {
  height: auto;
  width: 100%;
  background: red;
  border-radius: 100% 0% 100% 0% / 0% 50% 50% 100%;
  display: flex;
  place-items: center;
}

.card-header i {
  color: rgb(255, 255, 255);
  margin-top: 30px;
  font-size: 50px;
}
.card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 0 auto;
}
.card-title {
  text-align: center;
  text-transform: uppercase;
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 20px;
}
.card-text {
  text-align: left;
  font-size: 12x;
  margin-bottom: 20px;
  margin-left: 20px;
  margin-right: 20px;
}
.card-btn {
  border: none;
  border-radius: 100px;
  padding: 5px 30px;
  color: #fff;
  margin-bottom: 15px;
  /* text-transform: uppercase; */
}
.card-header.three {
  background: linear-gradient(
    to bottom left,
    var(--card3-gradient-color1),
    var(--card3-gradient-color2)
  );
}
.card-btn.three {
  background: green;
}
.card-btn.four {
  background: red;
}
.card-btn.five {
  background: blue;
}
.card-btn.six {
  background: purple;
}
.card-btn.seven {
  background: skyblue;
}
.card-btn.three:hover {
  transform: scale(1.1);
}
.card-btn.four:hover {
  transform: scale(1.1);
}
.card-btn.five:hover {
  transform: scale(1.1);
}
.card-btn.six:hover {
  transform: scale(1.1);
}
.card-btn.seven:hover {
  transform: scale(1.1);
}
.swal-wide {
  width: 1000px !important;
}
</style>
